
// 查询资源开关配置
export const GET_RESOURCE_SWITCH = 'eventsgo/media/services/eventsgo/config/resourceSwitchService/findResourceSwitch'
// 编辑资源开关配置
export const UPDATA_RESOURCE_SWITCH = 'eventsgo/media/services/eventsgo/config/resourceSwitchService/updateResourceSwitch'
// 查询资源配置是否存在订单
export const GET_ORDER_EXISTS = 'eventsgo/media/services/eventsgo/config/resourceSwitchService/findSwitchOrderExists'
// 查询流程开关配置
export const GET_PROCESS_SWITCH = 'eventsgo/media/services/eventsgo/config/processSwitchService/findWorkflowSwitch'
// 查询审批流程列表
export const GET_PROCESS_LIST = 'eventsgo/media/services/eventsgo/config/processSwitchService/findProcessList'
// 保存流程
export const SAVE_PROCESS = 'eventsgo/media/services/eventsgo/config/processSwitchService/saveProcessNodesByKey'
// 修改流程开关
export const UPDATE_PROCESS_SWITCH = 'eventsgo/media/services/eventsgo/config/processSwitchService/updateWorkflowSwitchByItemId'
// 查询流程开关修改日志
export const GET_PROCESS_SWITCH_HISTORY = 'eventsgo/media/services/eventsgo/config/processSwitchService/queryWorkflowSwitchLog'
